module.exports = __webpack_public_path__ + "static/media/delete_orange.e2b53454.svg";